<div class="page-wrapper">
	<aside class="sidebar-panel" [class.collapsed]="!sidebarVisible">
		<app-menu-sidebar class="menu" [isMobileViewMenu]="isMobileView" />
	</aside>

	@if (isMobileView && sidebarVisible) {
		<div class="sidebar-backdrop" (click)="closeSidebarOnMobile()"></div>
	}

	<div class="main-column">
	<header
		class="app-header sticky top-0 z-10 flex items-center justify-between gap-2 sm:gap-4 border-b border-gray-200 bg-white px-3 sm:px-4 py-2 shadow-sm"
	>
		<div class="flex items-center gap-2 sm:gap-4">
			<app-sidebar [(visible)]="sidebarVisible" />
			@if (pageTitle) {
				<span class="text-base sm:text-lg font-semibold text-gray-800 truncate">
					{{ pageTitle }}
				</span>
			}
		</div>

		<div class="flex items-center gap-1.5 sm:gap-3">
			<div
				class="relative group flex items-center gap-1.5 sm:gap-2 rounded-full bg-gray-100 px-2 sm:px-3 py-1 text-sm text-gray-700"
				[title]="farmName"
			>
				<i
					class="pi pi-map-marker text-gray-500"
					aria-hidden="true"
				></i>
				<span class="hidden sm:inline-block max-w-[100px] lg:max-w-[140px] truncate">
					{{ farmName }}
				</span>

				<span
					class="pointer-events-none absolute left-1/2 top-full z-20 mt-2 -translate-x-1/2 whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100"
				>
					{{ farmName }}
				</span>
			</div>

			<div
				class="relative group flex items-center gap-1.5 sm:gap-2 rounded-full bg-gray-100 px-2 sm:px-3 py-1 text-sm text-gray-700"
				[title]="userName"
			>
				<i class="pi pi-user text-gray-500" aria-hidden="true"></i>
				<span class="hidden sm:inline-block max-w-[100px] lg:max-w-[140px] truncate">
					{{ userName }}
				</span>

				<span
					class="pointer-events-none absolute left-1/2 top-full z-20 mt-2 -translate-x-1/2 whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100"
				>
					{{ userName }}
				</span>
			</div>

			<div class="hidden sm:block h-6 w-px bg-gray-200"></div>

			<lib-button
				class="shrink-0"
				[icon]="'pi pi-sign-out'"
				[severity]="'primary'"
				[variant]="'text'"
				[pTooltip]="'Sair'"
				(click)="logoutMenu()"
			></lib-button>
		</div>
	</header>

	<div class="body-wrapper">
		<app-section-component class="content">
			<router-outlet></router-outlet>
		</app-section-component>
	</div>
	</div>
</div>
